import {removeRecord} from 'core/History';
import {calcDailyBudget} from 'core/DailyBudget';
import {selectUpdaterFor} from '../selectUpdater';
import {budgetUpdaters as fromRegistry} from './updateBudget';

export function deleteRecord(state: CoreState, record: RecordEntry): CoreState {
  const {budget, history} = state;
  const updateBudget = selectUpdaterFor(record.type, fromRegistry);

  const newBudget = updateBudget(budget, record);
  const newHistory = removeRecord(history, record);
  const newDailyBudget = calcDailyBudget(newBudget, newHistory);

  return {
    ...state,
    budget: newBudget,
    history: newHistory,
    dailyBudget: newDailyBudget,
  };
}
